import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps';
import { STORE_MAP } from '@/config/cache/cache-engine';

export default {
    getWorksStaffPaymentRatesNorms: {
        useCache: true,
        cacheStorage: STORE_MAP.FULL,
        apiServiceMethodName: ModulesConfigMap[ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS].GET_WORKS_STAFF_PAYMENT_RATES_NORMS
    },
    getWorksStaffPaymentRatesNorm: {
        useCache: true,
		isSingleCachedEntity: true,
		cacheStorage: STORE_MAP.FULL,
        apiServiceMethodName: ModulesConfigMap[ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS].GET_WORKS_STAFF_PAYMENT_RATES_NORM
    },
    createWorksStaffPaymentRatesNorm: {
        apiServiceMethodName: ModulesConfigMap[ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS].CREATE_WORKS_STAFF_PAYMENT_RATES_NORM
    },
    putWorksStaffPaymentRatesNorm: {
        apiServiceMethodName: ModulesConfigMap[ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS].PUT_WORKS_STAFF_PAYMENT_RATES_NORM
    },
    patchWorksStaffPaymentRatesNorm: {
        apiServiceMethodName: ModulesConfigMap[ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS].PATCH_WORKS_STAFF_PAYMENT_RATES_NORM
    },
    deleteWorksStaffPaymentRatesNorm: {
        apiServiceMethodName: ModulesConfigMap[ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS].DELETE_WORKS_STAFF_PAYMENT_RATES_NORM
    }

}